import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Preview = forwardRef<SVGSVGElement | null, IconFilledProps>(function Preview({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.8759 12.2231C21.957 12.0819 21.957 11.9181 21.8759 11.7769C21.1906 10.5827 17.6826 5 11.9996 5C6.31658 5 2.80864 10.5827 2.12329 11.7769C2.04224 11.9181 2.04224 12.0819 2.12329 12.2231C2.80864 13.4173 6.31658 19 11.9996 19C17.6826 19 21.1906 13.4173 21.8759 12.2231ZM3.91281 11.742C3.80804 11.8982 3.80804 12.1018 3.91281 12.258C4.31649 12.8596 4.91405 13.659 5.68777 14.4534C7.25859 16.0661 9.39485 17.5 11.9996 17.5C14.6044 17.5 16.7406 16.0661 18.3115 14.4534C19.0852 13.659 19.6827 12.8596 20.0864 12.258C20.1912 12.1018 20.1912 11.8982 20.0864 11.742C19.6827 11.1404 19.0852 10.341 18.3115 9.54661C16.7406 7.93391 14.6044 6.5 11.9996 6.5C9.39485 6.5 7.25859 7.93391 5.68777 9.54661C4.91405 10.341 4.31649 11.1404 3.91281 11.742Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.9996 10.25C11.0331 10.25 10.2496 11.0335 10.2496 12C10.2496 12.9665 11.0331 13.75 11.9996 13.75C12.9661 13.75 13.7496 12.9665 13.7496 12C13.7496 11.0335 12.9661 10.25 11.9996 10.25ZM8.74962 12C8.74962 10.2051 10.2047 8.75 11.9996 8.75C13.7945 8.75 15.2496 10.2051 15.2496 12C15.2496 13.7949 13.7945 15.25 11.9996 15.25C10.2047 15.25 8.74962 13.7949 8.74962 12Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M10.2496 12C10.2496 11.0335 11.0331 10.25 11.9996 10.25C12.9661 10.25 13.7496 11.0335 13.7496 12C13.7496 12.9665 12.9661 13.75 11.9996 13.75C11.0331 13.75 10.2496 12.9665 10.2496 12Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.12329 11.7769C2.04224 11.9181 2.04224 12.0819 2.12329 12.2231C2.80864 13.4173 6.31658 19 11.9996 19C17.6826 19 21.1906 13.4173 21.8759 12.2231C21.957 12.0819 21.957 11.9181 21.8759 11.7769C21.1906 10.5827 17.6826 5 11.9996 5C6.31658 5 2.80864 10.5827 2.12329 11.7769ZM11.9996 8.75C10.2047 8.75 8.74962 10.2051 8.74962 12C8.74962 13.7949 10.2047 15.25 11.9996 15.25C13.7945 15.25 15.2496 13.7949 15.2496 12C15.2496 10.2051 13.7945 8.75 11.9996 8.75Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'revenue-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Preview;
